import { productActions } from '../config/actions';

const defaultState = {
  isLoading: null,
  data: [],
  currentProduct: null,
  error: null,
  history: [],
  evidence: null,
  message: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case productActions.PRODUCTS_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || [],
        error: null,
        evidence: null,
        history: state.history || []
      };
    case productActions.PRODUCTS_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        error: action.error,
        evidence: null,
        history: state.history || []
      };
    case productActions.PRODUCTS_NEW:
      return {
        ...state,
        isLoading: false,
        data: [action.data, ...state.data],
        error: null,
        evidence: null,
        history: state.history || []
      };
    case productActions.PRODUCTS:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        error: null,
        evidence: null,
        history: state.history || []
      };
    case productActions.PRODUCTS_RESET:
      return {
        ...state,
        isLoading: false,
        data: [],
        error: null,
        evidence: null,
        history: state.history || []
      };
    case productActions.SELECT_PRODUCT:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        currentProduct: action.data,
        error: null,
        history: state.history || []
      };
    case productActions.SELECT_PRODUCT_RESET:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        currentProduct: null,
        error: null,
        evidence: null,
        history: state.history || []
      };
    case productActions.PRODUCT_POSTCREATE:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        currentProduct: null,
        error: null,
        evidence: null,
        history: state.history || []
      };
    case productActions.PRODUCT_HISTORY:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        currentProduct: null,
        error: null,
        evidence: null,
        history: action.history
      };
    case productActions.PRODUCT_EVIDENCE:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        currentProduct: null,
        error: null,
        evidence: action.evidence,
        history: state.history || []
      };
    default:
      return state;
  }
};
